function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 26,
    height: 26,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 192,
    r: 96,
    fill: "#7821a0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.4,387.872c-108-90.656-264.832-90.656-372.832,0C2.048,390.848,0,395.264,0,399.904v44.192     C0,465.728,14.336,480,32,480h320c17.664,0,32-14.272,32-31.968v-43.456C384,395.264,381.952,390.848,378.4,387.872z",
    fill: "#7821a0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,192c0,10.912-1.408,21.504-4,31.584c1.376,0.064,2.624,0.416,4,0.416c52.928,0,96-43.072,96-96     c0-52.928-43.072-96-96-96c-32.832,0-61.792,16.608-79.104,41.792C287.264,93.056,320,138.752,320,192z",
    fill: "#7821a0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4,323.872c-58.88-49.408-132.256-71.68-204.32-67.2c-9.344,15.712-21.792,29.408-36.736,39.936     c48.352,11.328,94.688,33.728,134.816,67.712C410.528,373.088,416,386.432,416,400v16h64c17.664,0,32-14.336,32-32v-48     C512,331.36,509.952,326.848,506.4,323.872z",
    fill: "#7821a0",
    "data-original": "#000000",
    style: {},
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGroup);
export default __webpack_public_path__ + "static/media/ico-group.8452f99916f50d6a03e0cad72869adb2.svg";
export { ForwardRef as ReactComponent };